import { Loader } from "shared/components/Loader";
import moment from "moment";
import { useAuthContext } from "providers/Auth";
import { IconButton, IconButtonSize } from "shared/components";
import { RefreshCCW02 } from "untitledui-js-base";
import { cx } from "shared/utils";
import { useMedia } from "shared/providers";

type PropertyManagementSystemSync = {
  lastSuccessSyncedAt?: string;
  handleRequestSync?: () => void;
  isSyncing?: boolean;
  withDivider?: boolean;
  reversed?: boolean;
};

const formatDate = (date?: string) => {
  if (!date) return "N/A";

  return moment(date).format("MMM DD, YYYY, h:mm A");
};

const SyncButton = ({
  isSyncing,
  handleRequestSync,
  isMobile
}: {
  isSyncing?: boolean;
  handleRequestSync?: () => void;
  isMobile: boolean;
}) =>
  isSyncing ? (
    <Loader size={32} />
  ) : (
    <IconButton
      className="shrink-0"
      Icon={RefreshCCW02}
      onClick={handleRequestSync}
      size={isMobile ? IconButtonSize.BASE : IconButtonSize.SM}
    />
  );

const SyncLabel = ({
  lastSuccessSyncedAt
}: {
  lastSuccessSyncedAt?: string;
}) => (
  <p className="text-xs font-medium text-content-200 md:block hidden">
    Last sync: {formatDate(lastSuccessSyncedAt)}
  </p>
);

export const PropertyManagementSystemSync = ({
  lastSuccessSyncedAt,
  handleRequestSync,
  isSyncing,
  withDivider,
  reversed
}: PropertyManagementSystemSync) => {
  const { type } = useAuthContext();

  const { isMobile } = useMedia();

  if (!type.isPMS) return null;

  return (
    <div
      className={cx(
        "flex grow items-center gap-2",
        reversed && "justify-end",
        withDivider && "border-l border-alpha-40 pl-4"
      )}
    >
      {reversed ? (
        <>
          <SyncLabel lastSuccessSyncedAt={lastSuccessSyncedAt} />
          <SyncButton
            isSyncing={isSyncing}
            handleRequestSync={handleRequestSync}
            isMobile={isMobile}
          />
        </>
      ) : (
        <>
          <SyncButton
            isSyncing={isSyncing}
            handleRequestSync={handleRequestSync}
            isMobile={isMobile}
          />
          <SyncLabel lastSuccessSyncedAt={lastSuccessSyncedAt} />
        </>
      )}
    </div>
  );
};
